import { useEffect } from 'react';
import { type bindEmitterToWSClient, type EventCreatorWithKey } from '@epihub/core/src/events';
import { useLatestRef } from '../../hooks/useLatestRef';

export function createUseWSSubscription(wsClient: ReturnType<typeof bindEmitterToWSClient>) {
  return function useWSSubscription<Event extends EventCreatorWithKey<any, any>>(
    event: Event | null,
    cb: (data: Event extends EventCreatorWithKey<infer Data, any> ? Data : never) => void,
  ) {
    const cbRef = useLatestRef(cb);
    useEffect(() => {
      if (!event) {
        return;
      }

      const { unsubscribe } = wsClient.emitter.listen(event, (data) => {
        return cbRef.current(data);
      });

      return () => {
        unsubscribe();
      };
    }, [event?.key, cbRef]);
  };
}
